



































































































































































































































































import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { Blacklist } from '@/interfaces/blacklist';
import DropdownIconBar from '@/components/dropdowns/dropdown-icon-bar.vue';
import DropdownNotes from '@/components/dropdowns/dropdown-notes.vue'
import DropdownUpdates from '@/components/dropdowns/dropdown-updates.vue';
import { File } from '@/interfaces/file';
import { formatUtils } from '@/util/format-utils';
import { List } from '@/interfaces/list';
import { Modal } from 'bootstrap';
import ModalNoteDelete from '@/components/modals/modal-note-delete.vue';
import ModalNoteEdit from '@/components/modals/modal-note-edit.vue';
import { Note } from '@/interfaces/note';
import { ProcurementSearchItem } from '@/interfaces/search/procurement-search-item';
import { RouterNames } from '@/util/enums/router-names';
import { TableSizes } from '@/util/enums/table-sizes';

@Component({
  components: {
    DropdownIconBar,
    DropdownNotes,
    DropdownUpdates,
    ModalNoteEdit,
    ModalNoteDelete,
  },
})
export default class ProcurementList extends Vue {
  @Prop({ required: true }) procurements: ProcurementSearchItem[];
  @Prop({ default: false }) showNotes: boolean;
  @Prop({ default: null}) list: List;
  @Prop({ default: null }) filterFunc: (val: ProcurementSearchItem) => boolean;
  @Prop({ default: false }) colorSharedBlacklist: boolean;
  @Prop({ default: null }) limit: number;
  @Prop({ default: 'trademark' }) headerColor: string;
  @Prop({ default: 'white' }) headerText: string;
  @Prop({ default: 'white' }) itemColor: string;
  @Ref() procurementTableContainer: HTMLDivElement;
  selectedNote: Note = null;
  tableSize = 4000;
  allowClick = false;

  mounted() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  }

  activated() {
    this.resizeHandler();
  }

  get colClassesXl() {
    if (this.tableSize > TableSizes.xxl) {
      return [
        'col-1',
      ];
    } else {
      return [
        'col-2',
      ];
    }
  }

  get headerClasses() {
    return [
      'mb-2',
      `bg-${this.headerColor}`,
      `text-${this.headerText}`,
    ];
  }

  get items(): ProcurementSearchItem[] {
    const items: ProcurementSearchItem[] = this.procurements.filter(this.filterFunc ?? (() => true));
    if (this.limit != null) {
      return items.splice(0, this.limit);
    }
    return items;
  }

  get isShared(): boolean {
    return this.list && this.list.paUserIds.length > 1;
  }

  get userBlacklist() {
    return this.$vmx.blacklist.userBlacklists;
  }

  commonId(procurement: ProcurementSearchItem) {
    return `proc-${procurement.id}`;
  }

  firstCriteriaText(text: string): string {
    return text ? this.formatText(text, 15) : (this.$t('general.emptyField') as string);
  }

  formatDate(date: string) {
    return formatUtils.formatDate(date, 'DD.MM.YYYY');
  }

  formatText(text: string, maxChars: number) {
    if (text.length > maxChars) {
      return text.substring(0, maxChars) + '&hellip;';
    } else {
      return text;
    }
  }

  getCriteriaStringsOfType(procurement: ProcurementSearchItem, typeId: number): string[] {
    return procurement.criteria?.find(criterionData => criterionData.typeId === typeId)?.criteria ?? [];
  }

  imageFromFile(file: File) {
    if (file) {
      return 'url(' + (file.link ? file.link : this.$vmx.file.fromFile(`${file.code}.${file.extension}`, '1x1')) + ')';
    } else {
      return 'url(' + this.$vmx.file.fromFile(null, '1x1') + ')';
    }
  }

  isBlacklistedShared(procurement: ProcurementSearchItem) {
    if (!this.colorSharedBlacklist) {
      return false;
    }
    return this.$vmx.blacklist.blacklists.some((blacklist: Blacklist) => {
      if (procurement.id == blacklist.procurementId) {
        return blacklist.usersIds.length >= 2;
      }
      return false;
    })
  }

  noteDeleted(id: number) {
    const procurement = this.procurements.find((procurement) => procurement.id === this.selectedNote.procurementId);
    procurement.notes.splice(
      procurement.notes.findIndex((x) => x.id === id),
      1,
    );
    this.selectedNote = null;
  }

  noteId(procurement: ProcurementSearchItem) {
    return `note-list-${this.commonId(procurement)}`;
  }

  noteSaved(note: Note) {
    const procurement = this.procurements.find((procurement) => procurement.id === note.procurementId);
    if (procurement.notes.some((x) => x.id === note.id)) {
      procurement.notes = procurement.notes.map((obj) =>
        obj.id === note.id ? note : obj,
      );
    } else {
      procurement.notes.push(note);
      procurement.notes.sort((a, b) => (a.created > b.created ? -1 : 1));
    }
    this.selectedNote = null;
  }

  openDeleteNoteModal(id: number) {
    for (const procurement of this.items) {
      const note = procurement.notes.find((note) => note.id == id);
      if (note) {
        this.selectedNote = note;
        this.openModal(`delete-${this.noteId(procurement)}`);
      }
    }
  }

  openModal(modalId: string) {
    const element = document.getElementById(modalId);
    const modal = new Modal(element);
    modal.show();
  }

  public resizeHandler() {
    if (this.procurementTableContainer) {
      this.tableSize = this.procurementTableContainer.clientWidth;
    }
  }

  routerLink(id: number) {
    return {
      name: RouterNames.LOGGED_IN_PROCUREMENT_VIEW,
      params: { id: id.toString() },
    };
  }

  showAtSize(minSize: number) {
    return [
      this.tableSize < minSize ? 'd-none' : '',
    ];
  }
}
